import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IAppState } from 'config/redux/reducers';
import { fetchBinDiscountBanners } from 'common/BinDiscountBanner/redux/binDiscountBanner.action';
import useAction from 'hooks/useAction';

import { IBinDiscountBannerState } from '../redux/binDiscountBanner.reducer';

const useBinDiscountBanner = (): IBinDiscountBannerState => {
  const binDiscountBannerState = useSelector(
    ({ binDiscountBanner }: IAppState) => binDiscountBanner
  );
  const [fetchBinDiscountBannersAction] = useAction(fetchBinDiscountBanners);

  useEffect(() => {
    if (!binDiscountBannerState.data) {
      fetchBinDiscountBannersAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return binDiscountBannerState;
};

export default useBinDiscountBanner;
